var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Prop65 component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconProp65 extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.6927 21.603H1.37131C1.09586 21.603 0.841223 21.4557 0.703476 21.2167C0.565647 20.9778 0.565647 20.6833 0.703476 20.4444L11.3641 1.95161C11.5019 1.71264 11.7565 1.56543 12.032 1.56543C12.3075 1.56543 12.562 1.71264 12.6998 1.95161L23.3605 20.4444C23.4983 20.6833 23.4983 20.9778 23.3605 21.2167C23.2228 21.4557 22.9682 21.603 22.6927 21.603Z"
            fill="black"
          />
          <path d="M12.0322 3.89111L2.7148 20.0537H21.3496L12.0322 3.89111Z" fill="#FFFF00" />
          <path
            d="M12.0321 18.7071C11.4425 18.7071 10.9646 18.2284 10.9646 17.638C10.9646 17.0475 11.4425 16.5688 12.0321 16.5688C12.6217 16.5688 13.0996 17.0475 13.0996 17.638C13.0996 18.2284 12.6217 18.7071 12.0321 18.7071Z"
            fill="black"
          />
          <path
            d="M11.3836 15.3662L10.6178 8.37025C10.5554 7.79992 10.8387 7.24727 11.3379 6.9657C11.837 6.68412 12.4557 6.72785 12.9104 7.07693C13.365 7.426 13.5679 8.01305 13.4261 8.56891L12.6301 15.5119C12.6045 15.7351 12.4617 15.9278 12.2557 16.017C12.0497 16.1062 11.8118 16.0784 11.6318 15.9441C11.4518 15.8098 11.3572 15.5894 11.3836 15.3662Z"
            fill="black"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconProp65.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconProp65.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconProp65.prototype, "size", void 0);
if (customElements.get('cat-icon-prop65') === undefined) {
    customElements.define('cat-icon-prop65', BlocksIconProp65);
}
